
import Draw from 'ol/interaction/Draw';
import VectorSource from 'ol/source/Vector';

function createInteractionSelectObjectPolygon(options) {
    let source = new VectorSource({});

    let draw = new Draw({
        source: source,
        type: 'Polygon'
    });

    draw.set('mapToolId', 'SelectObjectPolygon');
    draw.setActive(false);

    draw.on('drawend', (e) => {
        if (options.onMapToolExecute) {
            options.onMapToolExecute(
                draw.get('mapToolId'),
                {
                    geometry: e.feature.get('geometry')
                }
            );
        }
    });

    return draw;
}

export default createInteractionSelectObjectPolygon;
